import useSWR from "swr";
import get from "lodash/get";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import upperFirst from "lodash/upperFirst";
import { Descriptions, Button } from "antd";
import Link from "next/link";
import { getCategoryLinkAttributes } from "grandus-lib/hooks/useFilter";
import { useTranslation } from 'next-i18next';

const CATEGORY_ID = 104339;
const PARAM_MODEL_ID = 2878;

const ProductPriceVariants = ({
  parameters,
  wrapperClassName = "",
  categories = [],
}) => {
  const { t } = useTranslation();
  const modelParam = find(parameters, ["parameterId", PARAM_MODEL_ID]);

  const url = get(modelParam, "value")
    ? `/api/pages/product/variants/price/${encodeURIComponent(
        get(modelParam, "value", "")
      )}?id=${PARAM_MODEL_ID}`
    : null;

  const pathParam = `${PARAM_MODEL_ID}/${encodeURIComponent(
    get(modelParam, "value")
  )}`;

  const { data } = useSWR(() => url, (url) => fetch(url).then((r) => r.json()), {
    revalidateOnReconnect: false,
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  });

  if (
    isEmpty(parameters) ||
    !find(get(categories, "[0]", []), { id: CATEGORY_ID })
  ) {
    return "";
  }

  if (!data || !get(data, "foundCategories", 0)) {
    return "";
  }

  return (
    <div className={wrapperClassName}>
      <Descriptions
        layout={"vertical"}
        size={"small"}
        column={get(data, "foundCategories", 2)}
      >
        {get(data, "variantNew.id") ? (
          <Descriptions.Item label={upperFirst(t("product:new phone"))}>
            <Link
              {...getCategoryLinkAttributes("nove-mobilne-telefony", pathParam)}
              scroll={true}
            >
              <Button>
                <b>
                  {t("common:from price")}{" "}
                  {get(data, "variantNew.finalPriceData.priceFormatted")}
                </b>
              </Button>
            </Link>
          </Descriptions.Item>
        ) : null}
        {get(data, "variantOpened.id") ? (
          <Descriptions.Item
            label={upperFirst(t("product:new phone from repurchase"))}
          >
            <Link
              {...getCategoryLinkAttributes("nove-z-vykupu", pathParam)}
              scroll={true}
            >
              <Button>
                <b>
                  {t("common:from price")}{" "}
                  {get(data, "variantOpened.finalPriceData.priceFormatted")}
                </b>
              </Button>
            </Link>
          </Descriptions.Item>
        ) : null}
        {get(data, "variantUsed.id") ? (
          <Descriptions.Item
            label={upperFirst(t("product:used phone from repurchase"))}
          >
            <Link
              {...getCategoryLinkAttributes("pouzite-z-vykupu", pathParam)}
              scroll={true}
            >
              <Button>
                <b>
                  {t("common:from price")}{" "}
                  {get(data, "variantUsed.finalPriceData.priceFormatted")}
                </b>
              </Button>
            </Link>
          </Descriptions.Item>
        ) : null}
      </Descriptions>
      <style jsx global>{`
        .ant-descriptions-item-container {
          justify-content: center;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default ProductPriceVariants;
